import { Message } from "element-ui";
import { Decimal } from "decimal.js";
export const getFileType = (fileName, type = '') => {
  // 后缀获取
  let suffix = "";
  // 获取类型结果
  let result;
  try {
    const flieArr = fileName.split(".");
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = "";
  }
  // fileName无后缀返回 false
  if (!suffix) {
    return false;
  }
  suffix = suffix.toLocaleLowerCase();
  // 图片格式
  const imglist = type ? ["png", "jpg", "jpeg", "svg"] : ["png", "jpg", "jpeg"];
  // 进行图片匹配
  result = imglist.find(item => item === suffix);
  if (result) {
    return "image";
  }
  // 匹配txt
  const txtlist = ["txt"];
  result = txtlist.find(item => item === suffix);
  if (result) {
    return "txt";
  }
  // 匹配 excel
  const excelist = ["xls", "xlsx"];
  result = excelist.find(item => item === suffix);
  if (result) {
    return "excel";
  }
  // 匹配 word
  const wordlist = ["doc", "docx"];
  result = wordlist.find(item => item === suffix);
  if (result) {
    return "word";
  }
  // 匹配 pdf
  const pdflist = ["pdf"];
  result = pdflist.find(item => item === suffix);
  if (result) {
    return "pdf";
  }
  // 匹配 ppt
  const pptlist = ["ppt", "pptx"];
  result = pptlist.find(item => item === suffix);
  if (result) {
    return "ppt";
  }
  // 匹配 视频
  const videolist = ["mp4", "m2v", "mkv", "rmvb", "wmv", "avi", "flv", "mov", "m4v"];
  result = videolist.find(item => item === suffix);
  if (result) {
    return "video";
  }
  // 匹配 音频
  const radiolist = ["mp3", "wav", "wmv"];
  result = radiolist.find(item => item === suffix);
  if (result) {
    return "audio";
  }
  // 其他 文件类型
  return "other";
};

export const downloadResponse = (response, notDownload = false) => {
  const filename = decodeURI(response.headers["content-disposition"].split("filename*=")[1]);
  if ("download" in document.createElement("a")) {
    return downloadFile(response.data, filename, notDownload);
  } else {
    Message.error("浏览器不支持");
  }
};

/**
 * blob下载（兼容IE）
 * @param {String} content 文件内容
 * @param {String} filename 文件名
 * @param notDownload
 */
export function downloadFile(content, filename, notDownload) {
  const blob = new Blob([content]);
  // IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    !notDownload && window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const objURL = window.URL.createObjectURL(blob);
    !notDownload && imatateDownloadByA(objURL, filename);
    return objURL;
  }
}

/**
 * 通过a标签模拟下载
 * @param {String} href
 * @param {String} filename
 */
export function imatateDownloadByA(href, filename) {
  const a = document.createElement("a");
  a.download = filename;
  a.style.display = "none";
  a.href = href;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
}

export const getFileSizeString = size => {
  if (!size) {
    return "0KB";
  }
  const num = new Decimal(size);
  if (num.div(1024).valueOf() < 1) {
    return `${num.valueOf()}B`;
  }
  if (num.div(1024).div(1024).valueOf() < 1) {
    return `${num.div(1024).toFixed(0).valueOf()}KB`;
  }
  if (num.div(1024).div(1024).div(1024).valueOf() < 1) {
    return `${num.div(1024).div(1024).toFixed(0).valueOf()}MB`;
  }

  return "";
};
